/**
 * First URL segment for club mini-site routes (must match backend CLUB_MINI_WEBSITE_PATH_PREFIX).
 * Example: prefix "club" → /club/{slug}/my-tickets/{orderId}
 */
export function getClubMiniWebsitePathPrefix() {
  const raw = (
    process.env.REACT_APP_CLUB_MINI_WEBSITE_PATH_PREFIX || "club"
  ).trim();
  const p = raw.replace(/^\/+|\/+$/g, "");
  return p || "club";
}
